import routerOptions0 from "/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}